import { https } from "./https";
import { PlaceOrderResponseOrder } from "./order";

export type PaymentSuccessPayload = {
  data: string;
};

export type PaymentSuccessResponseOrderDetails = PlaceOrderResponseOrder & {
  id: number;
};

export type PaymentSuccessResponse = {
  orderDetails: PaymentSuccessResponseOrderDetails;
  [k: string]: unknown;
};

export async function paymentSuccess(
  payload: PaymentSuccessPayload,
): Promise<PaymentSuccessResponse> {
  const { data } = await https({
    method: "post",
    url: "/payment/success",
    data: payload,
  });

  return data.data;
}
